import $ from 'jquery';
import './foundation';
import '../node_modules/slick-carousel/slick/slick.min';
import 'what-input';
import 'details-polyfill';
import objectFitImages from 'object-fit-images';

$(document).foundation();
addSecondaryArrows();

$(function () { objectFitImages(); });

$('#cta_modal').on('open.zf.reveal', function () {
    $('.cta-video')[0].play();
});
$('#cta_modal').on('closeme.zf.reveal', function () {
    $('.cta-video')[0].pause();
});
$('#cta_modal').on('closeme.zf.reveal', function () {
    $('.cta-video')[0].pause();
});

function addSecondaryArrows(){
    $('.button-arrow-anchor').append('<i class="arrow"></i>');
}



$('.project-list').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    nextArrow:'<div class="slick-next-button"><a class="button button-secondary" title="Next Projects">SEE MORE<i class="arrow"></i></a></div>',
    dots: true,
    responsive: [
        {
            breakpoint: 1290,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]

});


function watchForModalScroll() {
    $('.reveal-overlay').each(function(){
        var self = this;
        $(self).scroll(function () {
            setTimeout(function () {
                var scroll = $(self).scrollTop();
                var revealButton = $(self).find('.close-button');
                if (scroll >= 50 ){
                    $(revealButton).addClass('fixed');
                } else {
                    $(revealButton).removeClass('fixed');
                }
            }, 25);
        });
    });
}


function setMapSize() {
    if (($('body').hasClass('page-template-tempalate-locations')) && ($(window).width() > 899) ) {
        let container = $('.map-container');
        let containerHeight = $(container).outerHeight();
        let containerWidth = $(container).outerWidth();
        $('.map').height(containerHeight).width(containerWidth);
    } else {
        $('.map').height('').width('');
    }
}



$(document).ready(function () {
    setMapSize();
});

$(window).on('load', function(){
    watchForModalScroll();

});

$(window).on('resize', function () {
    setTimeout(function () {
        setMapSize();
    }, 25);
});


// WEBPACK FOOTER //
// ./src/index.js